import privateRoutes from "src/routes/private-routes";
import { SANDBOX_ROUTES, VERIFICATION_ROUTES } from "./routes";
import { BIG_FLIP_HELP_CENTER } from "./links";

export const ROLE_NAMES = {
  ADMIN: "ADMIN",
  APPROVER: "APPROVER",
  MAKER: "MAKER",
  DEVELOPER: "DEVELOPER",
  EXECUTOR: "EXECUTOR",
  REVIEWER: "REVIEWER",
  DEPOSIT_ADMIN: "DEPOSIT ADMIN",
  CUSTOMER_SERVICE: "CUSTOMER SERVICE",
  CHECKER: "CHECKER"
};

export const HIDE_BENEFICIARY_MENU_ROLES = [ROLE_NAMES.ADMIN, ROLE_NAMES.MAKER, ROLE_NAMES.EXECUTOR];
export const HIDE_CREATE_REFUND_MENU_ROLES = [ROLE_NAMES.MAKER, ROLE_NAMES.DEVELOPER, ROLE_NAMES.REVIEWER];

export const ROLE_ACCESS = {
  [ROLE_NAMES.ADMIN]: [
    ...SANDBOX_ROUTES,
    ...VERIFICATION_ROUTES,
    BIG_FLIP_HELP_CENTER,
    privateRoutes.home.path,
    privateRoutes.transaction.path,
    privateRoutes.transactionUploadSuperCsv.path,
    privateRoutes.transactionUploadBeneficiaryCsv.path,
    privateRoutes.transactionBeneficiaryList.path,
    privateRoutes.transactionMultiInput.path,
    privateRoutes.transactionReviewCsv.path,
    privateRoutes.transactionSummaryCsv.path,
    privateRoutes.transactionTransferReceiptCsv.path,
    privateRoutes.transactionTransferDeposit.path,
    privateRoutes.transactionMultiBeneficiary.path,
    privateRoutes.internationalTransaction.path,
    privateRoutes.internationalTransactionUploadExcel.path,
    privateRoutes.internationalTransactionMultiInput.path,
    privateRoutes.internationalTransactionReview.path,
    privateRoutes.internationalTransactionSummary.path,
    privateRoutes.internationalDepositPayment.path,
    privateRoutes.internationalUpdateRFI.path,
    privateRoutes.internationalTransactionApproval.path,
    privateRoutes.internationalTransactionApprovalReview.path,
    privateRoutes.internationalTransactionApprovalPayment.path,
    privateRoutes.internationalTransferReceiptCsv.path,
    privateRoutes.acceptPayment.path,
    privateRoutes.acceptPaymentHistory.path,
    privateRoutes.acceptPaymentRefundHistory.path,
    privateRoutes.acceptPaymentReport.path,
    privateRoutes.acceptPaymentConfiguration.path,
    privateRoutes.acceptPaymentFlipCheckoutPage.path,
    privateRoutes.acceptPaymentSettlementReport.path,
    privateRoutes.acceptPaymentLinkPreview.path,
    privateRoutes.historyTransaction.path,
    privateRoutes.historyMultiTransaction.path,
    privateRoutes.historyWaitingApproval.path,
    privateRoutes.historyTransactionDetail.path,
    privateRoutes.historyTransactionDraftDetail.path,
    privateRoutes.historyTransactionReport.path,
    privateRoutes.historyInternationalTransaction.path,
    privateRoutes.historyInternationalTransactionDetail.path,
    privateRoutes.historyInternationalTransactionReport.path,
    privateRoutes.approval.path,
    privateRoutes.approvalReview.path,
    privateRoutes.approvalSummary.path,
    privateRoutes.approvalDeposit.path,
    privateRoutes.approvalReceipt.path,
    privateRoutes.deposit.path,
    privateRoutes.depositTopUp.path,
    privateRoutes.depositTopUpPayment.path,
    privateRoutes.depositHistory.path,
    privateRoutes.depositStatement.path,
    privateRoutes.refund.path,
    privateRoutes.createRefund.path,
    privateRoutes.userManagement.path,
    privateRoutes.document.path,
    privateRoutes.settingsProfileAccount.path,
    privateRoutes.settingsNotification.path,
    privateRoutes.settingsApiSetting.path,
    privateRoutes.settingsTFA.path,
    privateRoutes.settingsTwoFactorAuth.path,
    privateRoutes.settingsCredentials.path,
    privateRoutes.settingsTransaction.path,
    privateRoutes.settingsDeposit.path,
    privateRoutes.settingsActivityLog.path
  ],
  [ROLE_NAMES.APPROVER]: [
    ...VERIFICATION_ROUTES,
    BIG_FLIP_HELP_CENTER,
    privateRoutes.home.path,
    privateRoutes.acceptPayment.path,
    privateRoutes.acceptPaymentHistory.path,
    privateRoutes.acceptPaymentRefundHistory.path,
    privateRoutes.acceptPaymentReport.path,
    privateRoutes.acceptPaymentLinkPreview.path,
    privateRoutes.historyTransaction.path,
    privateRoutes.historyMultiTransaction.path,
    privateRoutes.historyWaitingApproval.path,
    privateRoutes.historyTransactionDetail.path,
    privateRoutes.historyTransactionDraftDetail.path,
    privateRoutes.historyTransactionReport.path,
    privateRoutes.historyInternationalTransaction.path,
    privateRoutes.historyInternationalTransactionDetail.path,
    privateRoutes.historyInternationalTransactionReport.path,
    privateRoutes.internationalUpdateRFI.path,
    privateRoutes.internationalTransactionApproval.path,
    privateRoutes.internationalTransactionApprovalReview.path,
    privateRoutes.internationalTransactionApprovalPayment.path,
    privateRoutes.internationalDepositPayment.path,
    privateRoutes.internationalTransferReceiptCsv.path,
    privateRoutes.approval.path,
    privateRoutes.approvalReview.path,
    privateRoutes.approvalSummary.path,
    privateRoutes.approvalDeposit.path,
    privateRoutes.approvalReceipt.path,
    privateRoutes.deposit.path,
    privateRoutes.depositTopUp.path,
    privateRoutes.depositTopUpPayment.path,
    privateRoutes.depositHistory.path,
    privateRoutes.depositStatement.path,
    privateRoutes.beneficiaryList.path,
    privateRoutes.beneficiaryUpload.path,
    privateRoutes.beneficiaryReview.path,
    privateRoutes.settingsProfileAccount.path,
    privateRoutes.settingsTFA.path
  ],
  [ROLE_NAMES.CHECKER]: [
    ...VERIFICATION_ROUTES,
    BIG_FLIP_HELP_CENTER,
    privateRoutes.home.path,
    privateRoutes.acceptPayment.path,
    privateRoutes.acceptPaymentHistory.path,
    privateRoutes.acceptPaymentRefundHistory.path,
    privateRoutes.acceptPaymentReport.path,
    privateRoutes.acceptPaymentLinkPreview.path,
    privateRoutes.historyTransaction.path,
    privateRoutes.historyMultiTransaction.path,
    privateRoutes.historyWaitingApproval.path,
    privateRoutes.historyTransactionDetail.path,
    privateRoutes.historyTransactionDraftDetail.path,
    privateRoutes.historyTransactionReport.path,
    privateRoutes.historyInternationalTransaction.path,
    privateRoutes.historyInternationalTransactionDetail.path,
    privateRoutes.historyInternationalTransactionReport.path,
    privateRoutes.internationalUpdateRFI.path,
    privateRoutes.approval.path,
    privateRoutes.approvalReview.path,
    privateRoutes.approvalSummary.path,
    privateRoutes.approvalDeposit.path,
    privateRoutes.approvalReceipt.path,
    privateRoutes.deposit.path,
    privateRoutes.depositTopUp.path,
    privateRoutes.depositTopUpPayment.path,
    privateRoutes.depositHistory.path,
    privateRoutes.depositStatement.path,
    privateRoutes.beneficiaryList.path,
    privateRoutes.beneficiaryUpload.path,
    privateRoutes.beneficiaryReview.path,
    privateRoutes.settingsProfileAccount.path
  ],
  [ROLE_NAMES.MAKER]: [
    ...VERIFICATION_ROUTES,
    BIG_FLIP_HELP_CENTER,
    privateRoutes.home.path,
    privateRoutes.transaction.path,
    privateRoutes.transactionUploadSuperCsv.path,
    privateRoutes.transactionUploadBeneficiaryCsv.path,
    privateRoutes.transactionBeneficiaryList.path,
    privateRoutes.transactionMultiInput.path,
    privateRoutes.transactionReviewCsv.path,
    privateRoutes.transactionSummaryCsv.path,
    privateRoutes.transactionTransferDeposit.path,
    privateRoutes.transactionProcessMaker.path,
    privateRoutes.transactionMultiBeneficiary.path,
    privateRoutes.acceptPayment.path,
    privateRoutes.acceptPaymentHistory.path,
    privateRoutes.acceptPaymentRefundHistory.path,
    privateRoutes.acceptPaymentReport.path,
    privateRoutes.acceptPaymentConfiguration.path,
    privateRoutes.acceptPaymentFlipCheckoutPage.path,
    privateRoutes.acceptPaymentSettlementReport.path,
    privateRoutes.acceptPaymentLinkPreview.path,
    privateRoutes.historyTransaction.path,
    privateRoutes.historyMultiTransaction.path,
    privateRoutes.historyWaitingApproval.path,
    privateRoutes.historyTransactionDetail.path,
    privateRoutes.historyTransactionDraftDetail.path,
    privateRoutes.historyTransactionReport.path,
    privateRoutes.historyInternationalTransaction.path,
    privateRoutes.historyInternationalTransactionDetail.path,
    privateRoutes.historyInternationalTransactionReport.path,
    privateRoutes.internationalTransaction.path,
    privateRoutes.internationalTransactionUploadExcel.path,
    privateRoutes.internationalTransactionMultiInput.path,
    privateRoutes.internationalTransactionReview.path,
    privateRoutes.internationalUpdateRFI.path,
    privateRoutes.internationalTransactionApproval.path,
    privateRoutes.internationalTransactionApprovalReview.path,
    privateRoutes.deposit.path,
    privateRoutes.depositHistory.path,
    privateRoutes.depositStatement.path,
    privateRoutes.refund.path,
    privateRoutes.settingsProfileAccount.path,
    privateRoutes.settingsActivityLog.path,
    privateRoutes.document.path
  ],
  [ROLE_NAMES.DEVELOPER]: [
    ...SANDBOX_ROUTES,
    ...VERIFICATION_ROUTES,
    BIG_FLIP_HELP_CENTER,
    privateRoutes.home.path,
    privateRoutes.acceptPayment.path,
    privateRoutes.acceptPaymentHistory.path,
    privateRoutes.acceptPaymentRefundHistory.path,
    privateRoutes.acceptPaymentReport.path,
    privateRoutes.acceptPaymentConfiguration.path,
    privateRoutes.acceptPaymentSettlementReport.path,
    privateRoutes.acceptPaymentLinkPreview.path,
    privateRoutes.historyTransaction.path,
    privateRoutes.historyMultiTransaction.path,
    privateRoutes.historyWaitingApproval.path,
    privateRoutes.historyTransactionDetail.path,
    privateRoutes.historyTransactionDraftDetail.path,
    privateRoutes.historyTransactionReport.path,
    privateRoutes.historyInternationalTransaction.path,
    privateRoutes.historyInternationalTransactionDetail.path,
    privateRoutes.historyInternationalTransactionReport.path,
    privateRoutes.internationalUpdateRFI.path,
    privateRoutes.deposit.path,
    privateRoutes.depositHistory.path,
    privateRoutes.depositStatement.path,
    privateRoutes.beneficiaryList.path,
    privateRoutes.beneficiaryUpload.path,
    privateRoutes.beneficiaryReview.path,
    privateRoutes.refund.path,
    privateRoutes.document.path,
    privateRoutes.settingsProfileAccount.path,
    privateRoutes.settingsApiSetting.path,
    privateRoutes.settingsCredentials.path,
    privateRoutes.settingsTFA.path,
    privateRoutes.settingsTwoFactorAuth.path,
    privateRoutes.settingsActivityLog.path
  ],
  [ROLE_NAMES.EXECUTOR]: [
    ...VERIFICATION_ROUTES,
    BIG_FLIP_HELP_CENTER,
    privateRoutes.home.path,
    privateRoutes.transaction.path,
    privateRoutes.transactionUploadSuperCsv.path,
    privateRoutes.transactionUploadBeneficiaryCsv.path,
    privateRoutes.transactionBeneficiaryList.path,
    privateRoutes.transactionMultiInput.path,
    privateRoutes.transactionReviewCsv.path,
    privateRoutes.transactionSummaryCsv.path,
    privateRoutes.transactionTransferReceiptCsv.path,
    privateRoutes.transactionTransferDeposit.path,
    privateRoutes.transactionMultiBeneficiary.path,
    privateRoutes.internationalTransaction.path,
    privateRoutes.internationalTransactionUploadExcel.path,
    privateRoutes.internationalTransactionMultiInput.path,
    privateRoutes.internationalTransactionReview.path,
    privateRoutes.internationalTransactionSummary.path,
    privateRoutes.internationalDepositPayment.path,
    privateRoutes.internationalUpdateRFI.path,
    privateRoutes.internationalTransactionApproval.path,
    privateRoutes.internationalTransactionApprovalReview.path,
    privateRoutes.internationalTransactionApprovalPayment.path,
    privateRoutes.internationalTransferReceiptCsv.path,
    privateRoutes.acceptPayment.path,
    privateRoutes.acceptPaymentHistory.path,
    privateRoutes.acceptPaymentRefundHistory.path,
    privateRoutes.acceptPaymentReport.path,
    privateRoutes.acceptPaymentConfiguration.path,
    privateRoutes.acceptPaymentFlipCheckoutPage.path,
    privateRoutes.acceptPaymentSettlementReport.path,
    privateRoutes.acceptPaymentLinkPreview.path,
    privateRoutes.historyTransaction.path,
    privateRoutes.historyMultiTransaction.path,
    privateRoutes.historyWaitingApproval.path,
    privateRoutes.historyTransactionDetail.path,
    privateRoutes.historyTransactionDraftDetail.path,
    privateRoutes.historyTransactionReport.path,
    privateRoutes.historyInternationalTransaction.path,
    privateRoutes.historyInternationalTransactionDetail.path,
    privateRoutes.historyInternationalTransactionReport.path,
    privateRoutes.deposit.path,
    privateRoutes.depositTopUp.path,
    privateRoutes.depositTopUpPayment.path,
    privateRoutes.depositHistory.path,
    privateRoutes.depositStatement.path,
    privateRoutes.refund.path,
    privateRoutes.createRefund.path,
    privateRoutes.settingsProfileAccount.path,
    privateRoutes.settingsTFA.path,
    privateRoutes.settingsActivityLog.path,
    privateRoutes.document.path
  ],
  [ROLE_NAMES.REVIEWER]: [
    ...VERIFICATION_ROUTES,
    BIG_FLIP_HELP_CENTER,
    privateRoutes.home.path,
    privateRoutes.acceptPayment.path,
    privateRoutes.acceptPaymentHistory.path,
    privateRoutes.acceptPaymentRefundHistory.path,
    privateRoutes.acceptPaymentReport.path,
    privateRoutes.acceptPaymentConfiguration.path,
    privateRoutes.acceptPaymentSettlementReport.path,
    privateRoutes.acceptPaymentLinkPreview.path,
    privateRoutes.historyTransaction.path,
    privateRoutes.historyMultiTransaction.path,
    privateRoutes.historyWaitingApproval.path,
    privateRoutes.historyTransactionDetail.path,
    privateRoutes.historyTransactionDraftDetail.path,
    privateRoutes.historyTransactionReport.path,
    privateRoutes.historyInternationalTransaction.path,
    privateRoutes.historyInternationalTransactionDetail.path,
    privateRoutes.historyInternationalTransactionReport.path,
    privateRoutes.internationalUpdateRFI.path,
    privateRoutes.deposit.path,
    privateRoutes.depositTopUp.path,
    privateRoutes.depositTopUpPayment.path,
    privateRoutes.depositHistory.path,
    privateRoutes.depositStatement.path,
    privateRoutes.beneficiaryList.path,
    privateRoutes.beneficiaryUpload.path,
    privateRoutes.beneficiaryReview.path,
    privateRoutes.refund.path,
    privateRoutes.settingsProfileAccount.path,
    privateRoutes.settingsActivityLog.path,
    privateRoutes.document.path
  ],
  [ROLE_NAMES.DEPOSIT_ADMIN]: [
    ...VERIFICATION_ROUTES,
    BIG_FLIP_HELP_CENTER,
    privateRoutes.home.path,
    privateRoutes.deposit.path,
    privateRoutes.depositTopUp.path,
    privateRoutes.depositTopUpPayment.path,
    privateRoutes.depositHistory.path,
    privateRoutes.depositStatement.path,
    privateRoutes.refund.path,
    privateRoutes.createRefund.path,
    privateRoutes.settingsProfileAccount.path,
    privateRoutes.settingsActivityLog.path,
    privateRoutes.document.path
  ],
  [ROLE_NAMES.CUSTOMER_SERVICE]: [
    BIG_FLIP_HELP_CENTER,
    privateRoutes.home.path,
    privateRoutes.acceptPaymentHistory.path,
    privateRoutes.acceptPaymentRefundHistory.path,
    privateRoutes.historyTransaction.path,
    privateRoutes.historyTransactionDetail.path,
    privateRoutes.historyInternationalTransaction.path,
    privateRoutes.historyInternationalTransactionDetail.path,
    privateRoutes.refund.path,
    privateRoutes.createRefund.path,
    privateRoutes.settingsActivityLog.path
  ]
};
